const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMSAxNVYxN0gyM1YxOUgyMVYyMUgxOVYxOUgxN1YxN0gxOVYxNUgyMVpNMjEuMTgxOCAzQzIyLjE4NiAzIDIzIDMuODk1NDMgMjMgNVYxM0gyMVYxMEgzVjE3SDE0VjE5SDIuODE4MThDMS44MTQwMyAxOSAxIDE4LjEwNDYgMSAxN1Y1QzEgMy44OTU0MyAxLjgxNDAzIDMgMi44MTgxOCAzSDIxLjE4MThaTTIxIDVIM1Y4SDIxVjVaIi8+Cjwvc3ZnPgo=";
export {
  M as default
};
//# sourceMappingURL=card_add-d122186d.mjs.map
